export const FETCH_ALL = "FETCH_ALL";
export const POST = "POST";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const SORT = "SORT";